module.exports = __webpack_public_path__ + "img/daolu.b3233848.png";